<script lang="ts">
    import {Link} from 'svelte-routing'
    import logo from 'src/components/cabinet/#assets/logo.svg'
    import IconifyIcon from '@iconify/svelte'
    import homeIcon from '@iconify/icons-fa-solid/home'
    import chartPieIcon from '@iconify/icons-fa-solid/chart-pie'
    import coinsIcon from '@iconify/icons-fa-solid/coins'
    import usersIcon from '@iconify/icons-fa-solid/users'
    import crownIcon from '@iconify/icons-fa-solid/crown'
    import swapIcon from '@iconify/icons-fa-solid/retweet'
    import bellIcon from '@iconify/icons-fa-solid/bell'
    import refundIcon from '@iconify/icons-fa-solid/money-bill-wave'
    import envelopeIcon from '@iconify/icons-fa-solid/envelope'
    import historyIcon from '@iconify/icons-fa-solid/history'
    import cogIcon from '@iconify/icons-fa-solid/cog'
    import userShieldIcon from '@iconify/icons-fa-solid/user-shield'
    import menuIcon from '@iconify/icons-fa-solid/bars'
    import blogIcon from '@iconify/icons-fa-solid/newspaper'
    import pollIcon from '@iconify/icons-fa-solid/poll'
    import mouseIcon from '@iconify/icons-fa-solid/mouse'
    import dragonIcon from '@iconify/icons-fa-solid/dragon'
    import walletIcon from '@iconify/icons-fa-solid/wallet'
    import tasksIcon from '@iconify/icons-fa-solid/tasks'
    import robotIcon from '@iconify/icons-fa-solid/robot'
    import Close from 'src/components/#common/#assets/close.svg'
    import {myRole} from 'src/components/#common/myRole'
    import {getNotConfirmedActionsCount} from 'src/components/cabinet/#services/confirmationActions'
    import chevronRightIcon from '@iconify/icons-fa-solid/chevron-right'

    let url = window.location.pathname
    let menuOpen = false

    getNotConfirmedActionsCount.reset()
    getNotConfirmedActionsCount.send()
</script>
<div class="menu-backdrop" class:active={menuOpen} on:click={() => menuOpen = false}></div>
<button class="hamburger-btn" class:active={menuOpen} on:click={() => menuOpen = true}>
    <IconifyIcon icon={menuIcon}/>
</button>
<div class="leftside-menu" class:active={menuOpen}>
    <Link to="/" class="logo">
        <span class="logo-lg">
            <img src="{logo}" alt="">
        </span>
    </Link>
    <button class="menu-close-btn" class:active={menuOpen} on:click={() => menuOpen = false} style="--Close:url({Close})"></button>
    <div class="h-100 overflow-auto">
        <ul class="side-nav">
            <li class="side-nav-item {url === '/' ? 'menuitem-active' : ''}">
                <Link to="/" class="side-nav-link">
                    <IconifyIcon icon={homeIcon} class="side-nav-icon"/>
                    <span>Dashboard</span>
                </Link>
            </li>
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("analytics")}
            <li class="side-nav-item {url === '/analytics' ? 'menuitem-active' : ''}">
                <Link to="/analytics" class="side-nav-link">
                    <IconifyIcon icon={chartPieIcon} class="side-nav-icon"/>
                    <span>Analytics</span>
                </Link>
            </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("transactions")}
            <li class="side-nav-item" class:menuitem-active={['/transactions', '/refunds', '/withdrawals', '/deposits', '/marketplace', '/swaps'].includes(url)}>
                <Link to="/transactions" class="side-nav-link">
                    <IconifyIcon icon={coinsIcon} class="side-nav-icon"/>
                    <span>Transactions</span>
                    <span class="menu-arrow">
                        <IconifyIcon icon={chevronRightIcon}/>
                    </span>
                </Link>
                <div class:collapsed={['/transactions', '/refunds', '/withdrawals', '/deposits', '/marketplace', '/swaps'].includes(url)}
                     class:collapse={!['/transactions', '/refunds', '/withdrawals', '/deposits', '/marketplace', '/swaps'].includes(url)}>
                    <ul class="side-nav-second-level">
                        <li class:active={url === '/transactions'}><Link to="/transactions">All transactions</Link></li>
                        <li class:active={url === '/refunds'}><Link to="/refunds">Refunds</Link></li>
                        <li class:active={url === '/withdrawals'}><Link to="/withdrawals">Withdrawals</Link></li>
                        <li class:active={url === '/deposits'}><Link to="/deposits">Deposits</Link></li>
                        <li class:active={url === '/marketplace'}><Link to="/marketplace">Marketplace</Link></li>
                        <li class:active={url === '/swaps'}><Link to="/swaps">SWAP</Link></li>
                    </ul>
                </div>
            </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("users")}
            <li class="side-nav-item" class:menuitem-active={['/users', '/holders', '/multiaccounts', '/membership-owners'].includes(url)}>
                <Link to="/users" class="side-nav-link">
                    <IconifyIcon icon={usersIcon} class="side-nav-icon"/>
                    <span>Users</span>
                    <span class="menu-arrow">
                    <IconifyIcon icon={chevronRightIcon}/>
                </span>
                </Link>
                <div class:collapsed={['/users', '/holders', '/multiaccounts', '/membership-owners'].includes(url)}
                     class:collapse={!['/users', '/holders', '/multiaccounts', '/membership-owners'].includes(url)}>
                    <ul class="side-nav-second-level">
                        <li class:active={url === '/users'}><Link to="/users">Search</Link></li>
                        {#if $myRole.hasValue && $myRole?.value?.pages?.includes('holders')}
                        <li class:active={url === '/holders'}><Link to="/holders">Holders</Link></li>
                        {/if}
                        <li class:active={url === '/multiaccounts'}><Link to="/multiaccounts">Multi Accounts</Link></li>
                        <li class:active={url === '/membership-owners'}><Link to="/membership-owners">Membership Owners</Link></li>
                    </ul>
                </div>
            </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("memberships")}
            <li class="side-nav-item {url === '/memberships' ? 'menuitem-active' : ''}">
                <Link to="/memberships" class="side-nav-link">
                    <IconifyIcon icon={crownIcon} class="side-nav-icon"/>
                    <span>Memberships</span>
                </Link>
            </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("notifications")}
            <!--<li class="side-nav-item {url === '/notifications' ? 'menuitem-active' : ''}">
                <Link to="/notifications" class="side-nav-link">
                    <IconifyIcon icon={bellIcon} class="side-nav-icon"/>
                    <span>Notifications</span>
                </Link>
            </li>-->
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("administrators")}
            <li class="side-nav-item {url === '/administrators' ? 'menuitem-active' : ''}">
                <Link to="/administrators" class="side-nav-link">
                    <IconifyIcon icon={userShieldIcon} class="side-nav-icon"/>
                    <span>Administrators</span>
                </Link>
            </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("marketplace")}
                <li class="side-nav-item {url === '/marketplace' ? 'menuitem-active' : ''}">
                    <Link to="/marketplace" class="side-nav-link">
                        <IconifyIcon icon={swapIcon} class="side-nav-icon"/>
                        <span>Marketplace</span>
                    </Link>
                </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("swap")}
                <li class="side-nav-item {url === '/swap' ? 'menuitem-active' : ''}">
                    <Link to="/swap" class="side-nav-link">
                        <IconifyIcon icon={swapIcon} class="side-nav-icon"/>
                        <span>Swap</span>
                    </Link>
                </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("nft")}
            <li class="side-nav-item {url === '/nft' ? 'menuitem-active' : ''}">
                <Link to="/nft" class="side-nav-link">
                    <IconifyIcon icon={dragonIcon} class="side-nav-icon"/>
                    <span>NFT creator</span>
                </Link>
            </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("deposit-wallets")}
                <li class="side-nav-item {url === '/deposit-wallets' ? 'menuitem-active' : ''}">
                    <Link to="/deposit-wallets" class="side-nav-link">
                        <IconifyIcon icon={walletIcon} class="side-nav-icon"/>
                        <span>Deposit wallets</span>
                    </Link>
                </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("emails")}
            <li class="side-nav-item {url === '/emails' || url === '/emails/edit' ? 'menuitem-active' : ''}">
                <Link to="/emails" class="side-nav-link">
                    <IconifyIcon icon={envelopeIcon} class="side-nav-icon"/>
                    <span>Emails</span>
                </Link>
            </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("blog")}
                <li class="side-nav-item {url === '/blog' || url === '/blog/add' || url === '/blog/edit' ? 'menuitem-active' : ''}">
                    <Link to="/blog" class="side-nav-link">
                        <IconifyIcon icon={blogIcon} class="side-nav-icon"/>
                        <span>Blog</span>
                    </Link>
                </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("polls")}
                <li class="side-nav-item {url === '/polls' || url === '/polls/add' || url === '/polls/edit' ? 'menuitem-active' : ''}">
                    <Link to="/polls" class="side-nav-link">
                        <IconifyIcon icon={pollIcon} class="side-nav-icon"/>
                        <span>Polls</span>
                    </Link>
                </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("news")}
                <li class="side-nav-item {url === '/news' || url === '/news/add' || url === '/news/edit' ? 'menuitem-active' : ''}">
                    <Link to="/news" class="side-nav-link">
                        <IconifyIcon icon={blogIcon} class="side-nav-icon"/>
                        <span>Game news</span>
                    </Link>
                </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("tasks")}
                <li class="side-nav-item {url === '/tasks' || url === '/tasks/all' || url === '/tasks/add' || url === '/tasks/leaderboard' || url === '/tasks/edit' ? 'menuitem-active' : ''}">
                    <Link to="/tasks" class="side-nav-link">
                        <IconifyIcon icon={tasksIcon} class="side-nav-icon"/>
                        <span>Quests Bot</span>
                    </Link>
                </li>
                <li class="side-nav-item {url === '/k-tasks' || url === '/k-tasks/all' || url === '/k-tasks/add' || url === '/k-tasks/leaderboard' || url === '/k-tasks/edit' ? 'menuitem-active' : ''}">
                    <Link to="/k-tasks" class="side-nav-link">
                        <IconifyIcon icon={robotIcon} class="side-nav-icon"/>
                        <span>Kitsune Bot</span>
                    </Link>
                </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("confirmations")}
                <li class="side-nav-item {url === '/confirmations' ? 'menuitem-active' : ''}">
                    <Link to="/confirmations" class="side-nav-link">
                        <IconifyIcon icon={mouseIcon} class="side-nav-icon"/>
                        <span>Confirmations</span>
                        {#if $getNotConfirmedActionsCount.hasValue && $getNotConfirmedActionsCount.value > 0}
                            <span class="notification-count">{$getNotConfirmedActionsCount.value}</span>
                        {/if}
                    </Link>
                </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("actions")}
            <li class="side-nav-item {url === '/actions' ? 'menuitem-active' : ''}">
                <Link to="/actions" class="side-nav-link">
                    <IconifyIcon icon={historyIcon} class="side-nav-icon"/>
                    <span>Actions</span>
                </Link>
            </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("app-configs")}
            <li class="side-nav-item {url === '/app-configs' ? 'menuitem-active' : ''}">
                <Link to="/app-configs" class="side-nav-link">
                    <IconifyIcon icon={cogIcon} class="side-nav-icon"/>
                    <span>App configs</span>
                </Link>
            </li>
            {/if}
            {#if $myRole.hasValue && $myRole?.value?.pages?.includes("settings")}
            <li class="side-nav-item {url === '/settings' ? 'menuitem-active' : ''}">
                <Link to="/settings" class="side-nav-link">
                    <IconifyIcon icon={cogIcon} class="side-nav-icon"/>
                    <span>Settings</span>
                </Link>
            </li>
            {/if}
        </ul>
        <div class="clearfix"></div>
    </div>
</div>

<style>
    @import "../../../../styles/global/scrollbar.pcss";

    .overflow-auto {
        @include scrollbar;
        @include scroll-smooth;
    }

    .leftside-menu {
        width: 260px;
        z-index: 10;
        background: #313a46;
        bottom: 0;
        position: fixed;
        top: 0;
        padding-top: 80px;
        -webkit-box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
        box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
    }

    .side-nav-item :global(.side-nav-icon) {
        display: inline-block;
        line-height: 1.0625rem;
        margin: 0 10px 0 0;
        font-size: 1.1rem;
        vertical-align: middle;
        width: 20px;
    }

    .menu-close-btn {
        display: none;
    }

    .menu-arrow :global(svg) {
        font-size: 12px;
    }

    .menuitem-active .menu-arrow :global(svg) {
        transform: rotate(90deg);
    }

    ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    .side-nav-second-level li :global(a) {
        padding: 8px 30px 8px 65px;
        color: #8391a2;
        display: block;
        position: relative;
        transition: all .25s;
        font-size: .89rem;
    }

    .side-nav-second-level li :global(a:hover) {
        color: #bccee4;
    }

    .side-nav-second-level li.active :global(a) {
        color: white !important;
    }

    .leftside-menu :global(.logo) {
        display: block;
        line-height: 70px;
        width: 260px;
        position: fixed;
        top: 0;
    }

    .leftside-menu :global(.logo img) {
        width: 120px;
        margin: 12px 0 0 30px;
        display: block;
    }

    .side-nav {
        padding-left: 0;
        list-style-type: none;
    }

    .side-nav :global(.side-nav-link) {
        display: block;
        padding: 10px 30px;
        font-size: .9375rem;
        position: relative;
        -webkit-transition: all .4s;
        transition: all .4s;
        list-style: none;
        color: #8391a2;
    }

    .side-nav :global(.side-nav-link:hover) {
        color: #bccee4;
    }

    .side-nav :global(.side-nav-link > i) {
        display: inline-block;
        line-height: 1.0625rem;
        margin: 0 10px 0 0;
        font-size: 1.1rem;
        vertical-align: middle;
        width: 20px;
    }

    .side-nav :global(.side-nav-link span) {
        vertical-align: middle;
    }

    .side-nav :global(.menu-arrow) {
        transition: transform .15s;
        position: absolute;
        right: 30px;
        display: inline-block;
        text-rendering: auto;
        line-height: 1.5rem;
        font-size: 1.1rem;
        -webkit-transform: translate(0,0);
        transform: translate(0,0);
    }

    .side-nav :global(.menu-arrow i) {
        font-size: 12px;
    }

    .side-nav :global(.collapse:not(.show)) {
        display: none;
    }

    .side-nav :global(.menuitem-active>a) {
        color: #fff!important;
    }

    .hamburger-btn {
        display: none;
    }

    .menu-backdrop {
        display: none;
    }

    .notification-count {
        background: #ff5d1c;
        display: inline-block;
        min-width: 22px;
        padding: 0 3px;
        text-align: center;
        margin-left: 8px;
        border-radius: 3px;
        color: white;
    }

    @media (max-width: 991px) {
        .leftside-menu {
            left: -260px;
            transition: .3s;
        }

        .leftside-menu.active {
            left: 0;
        }

        .hamburger-btn {
            display: block;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 6;
            border: 0;
            padding: 21px 25px;
            background: none;
            font-size: 22px;
            color: #98a6ad;
            line-height: 28px;
            border-right: 1px solid #f1f3fa;
        }

        .menu-backdrop {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.3);
            z-index: 5;
            visibility: hidden;
            opacity: 0;
            transition: opacity .25s;
            cursor: pointer;
        }

        .menu-backdrop.active {
            visibility: visible;
            opacity: 1;
        }

        .leftside-menu .logo img {
            width: 100px;
            margin: 10px 20px 0;
        }

        .menu-close-btn {
            display: block;
            position: absolute;
            top: 15px;
            right: 20px;
            border: 0;
            font-size: 24px;
            color: white;
            background: var(--Close) no-repeat;
            width: 20px;
            height: 20px;
            opacity: 0.8;
            z-index: 2;
        }
    }
</style>
